import { CountryCodes } from '@cnx-saas/common/generated';

interface CountryName {
  code: CountryCodes;
  name: string;
}

type CountryNameLanguages = 'en' | 'de' | 'pl';

type TranslatedCountryNames = {
  [key in CountryNameLanguages]: CountryName[];
};

export const countryNames = (language: CountryNameLanguages) => {
  const names: TranslatedCountryNames = {
    en: [
      { code: CountryCodes['At'], name: 'Austria' },
      { code: CountryCodes['Be'], name: 'Belgium' },
      { code: CountryCodes['Ba'], name: 'Bosnia and Herzegovina' },
      { code: CountryCodes['Hr'], name: 'Croatia' },
      { code: CountryCodes['Cz'], name: 'Czech Republic' },
      { code: CountryCodes['Dk'], name: 'Denmark' },
      { code: CountryCodes['Fr'], name: 'France' },
      { code: CountryCodes['De'], name: 'Germany' },
      { code: CountryCodes['Ie'], name: 'Ireland' },
      { code: CountryCodes['It'], name: 'Italy' },
      { code: CountryCodes['Lv'], name: 'Latvia' },
      { code: CountryCodes['Lu'], name: 'Luxembourg' },
      { code: CountryCodes['Nl'], name: 'Netherlands' },
      { code: CountryCodes['Pl'], name: 'Poland' },
      { code: CountryCodes['Pt'], name: 'Portugal' },
      { code: CountryCodes['Sk'], name: 'Slovakia' },
      { code: CountryCodes['Si'], name: 'Slovenia' },
      { code: CountryCodes['Es'], name: 'Spain' },
      { code: CountryCodes['Ch'], name: 'Switzerland' },
      { code: CountryCodes['Ua'], name: 'Ukraine' },
      { code: CountryCodes['Gb'], name: 'United Kingdom' },
    ],
    de: [
      { code: CountryCodes['At'], name: 'Österreich' },
      { code: CountryCodes['Be'], name: 'Belgien' },
      { code: CountryCodes['Ba'], name: 'Bosnien und Herzegowina' },
      { code: CountryCodes['Hr'], name: 'Kroatien' },
      { code: CountryCodes['Dk'], name: 'Dänemark' },
      { code: CountryCodes['Fr'], name: 'Frankreich' },
      { code: CountryCodes['De'], name: 'Deutschland' },
      { code: CountryCodes['Ie'], name: 'Irland' },
      { code: CountryCodes['It'], name: 'Italien' },
      { code: CountryCodes['Lv'], name: 'Lettland' },
      { code: CountryCodes['Lu'], name: 'Luxemburg' },
      { code: CountryCodes['Nl'], name: 'Niederlande' },
      { code: CountryCodes['Pl'], name: 'Polen' },
      { code: CountryCodes['Pt'], name: 'Portugal' },
      { code: CountryCodes['Sk'], name: 'Slowakei' },
      { code: CountryCodes['Si'], name: 'Slowenien' },
      { code: CountryCodes['Es'], name: 'Spanien' },
      { code: CountryCodes['Ch'], name: 'Schweiz' },
      { code: CountryCodes['Cz'], name: 'Tschechien' },
      { code: CountryCodes['Ua'], name: 'Ukraine' },
      { code: CountryCodes['Gb'], name: 'Vereinigtes Königreich' },
    ],
    pl: [
      { code: CountryCodes['At'], name: 'Austria' },
      { code: CountryCodes['Be'], name: 'Belgia' },
      { code: CountryCodes['Ba'], name: 'Bośnia i Hercegowina' },
      { code: CountryCodes['Hr'], name: 'Chorwacja' },
      { code: CountryCodes['Cz'], name: 'Czechy' },
      { code: CountryCodes['Dk'], name: 'Dania' },
      { code: CountryCodes['Fr'], name: 'Francja' },
      { code: CountryCodes['De'], name: 'Niemcy' },
      { code: CountryCodes['Ie'], name: 'Irlandia' },
      { code: CountryCodes['It'], name: 'Włochy' },
      { code: CountryCodes['Lv'], name: 'Łotwa' },
      { code: CountryCodes['Lu'], name: 'Luksemburg' },
      { code: CountryCodes['Nl'], name: 'Holandia' },
      { code: CountryCodes['Pl'], name: 'Polska' },
      { code: CountryCodes['Pt'], name: 'Portugalia' },
      { code: CountryCodes['Sk'], name: 'Słowacja' },
      { code: CountryCodes['Si'], name: 'Słowenia' },
      { code: CountryCodes['Es'], name: 'Hiszpania' },
      { code: CountryCodes['Ch'], name: 'Szwajcaria' },
      { code: CountryCodes['Ua'], name: 'Ukraina' },
      { code: CountryCodes['Gb'], name: 'Wielka Brytania' },
    ],
  };

  return names[language];
};

export type { CountryName, CountryNameLanguages };
